import server from "../../../../server";
import { IEmployeeDetail } from "../../../../domains/models/employee";
import { getName } from "../../../../utility/utility";

const defaultPageNumber = 0;
const defaultPageSize = 10;
const nameRegex = /^[A-Za-z\s]+$/;
const employeeCodeRegex = /^[A-Za-z0-9]+$/;

export async function getEmployeeDetailById(id:string) {
  const res=await server.employee.employeeDetailsByID(id,{});
  return {
      id: res.id,
      active: res.active,
      name: getName(res.name.firstName, res.name?.middleName??'', res.name.lastName),
      designation: res.designation?.displayName,
      employeeCode: res.employeeCode,
  }
}


export async function getEmployeeList(searchQuery: string, pageSize = defaultPageSize, pageNumber = defaultPageNumber) {
    let name, employeeCode;

    if (nameRegex.test(searchQuery)) {
        name = searchQuery;
    } else if (employeeCodeRegex.test(searchQuery)) {
        employeeCode = searchQuery;
    }

    const payload = {
        active: true,
        name: name,
        employeeCode: employeeCode
    }

    const response = await server.employee.search(payload, pageSize, pageNumber);
    const mappedResponse = viewMapper(response);
    return mappedResponse;

}

export function viewMapper(response: IEmployeeDetail[]) {
    const uniqueEmployees = Array.from(
        new Map(response.map((emp:any) => [emp.id, emp])).values()
    );
    return (uniqueEmployees.map((emp) => {
        return {
            id: emp.id,
            active: emp.active,
            name: getName(emp.name.firstName, emp.name?.middleName??'', emp.name.lastName),
            designation: emp.designation?.displayName,
            employeeCode: emp.employeeCode,
        }
    }))

}
